import React from 'react';
import { motion } from 'framer-motion';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { useTranslation } from '../hooks/useTranslation';

export default function ImpressumPageRU() {
  const { currentLanguage } = useTranslation();
  
  // Отладочная информация
  console.log('ImpressumPageRU - currentLanguage:', currentLanguage);
  
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.1, delayChildren: 0.2 },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 },
  };

  return (
    <div className="min-h-screen bg-white text-dark-900">
      <Header />
      <main className="pt-16 sm:pt-20">
        <motion.section
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="py-8 sm:py-16 lg:py-20"
        >
          <div className="max-w-4xl mx-auto px-3 sm:px-4 lg:px-8">
            <motion.div variants={item} className="text-center mb-8 sm:mb-12">
              <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4 sm:mb-6 text-dark-900">
                Правовая информация
              </h1>
              <p className="text-sm sm:text-base text-gray-600">
                Информация согласно § 5 Закона о телемедиа (TMG)
              </p>
            </motion.div>

            <motion.div variants={item} className="prose prose-sm sm:prose-lg max-w-none">
              {/* Информация о поставщике */}
              <div className="bg-gray-50 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">
                  Информация о поставщике и ответственность за контент согласно § 55 Abs. 2 RStV
                </h2>
                <div className="text-sm sm:text-base text-gray-700">
                  <p className="font-semibold mb-2">Альфира Херрманн</p>
                  <p>Hochburger Str. 32</p>
                  <p>79312 Emmendingen</p>
                </div>
              </div>

              {/* Контакт */}
              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">Контакт</h2>
                <div className="text-sm sm:text-base text-gray-700 space-y-1">
                  <p><strong>Телефон:</strong> +49 (0) 07641 95 37 645</p>
                  <p><strong>E-Mail:</strong> alphavita@gmx.de</p>
                  <p><strong>Налоговый номер:</strong> DE05196/00990</p>
                </div>
              </div>

              {/* Профессиональные квалификации */}
              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">Профессиональные квалификации</h2>
                <div className="text-sm sm:text-base text-gray-700 space-y-3">
                  <p>
                    <strong>Гипно-коуч (DHV)</strong> - получено в Германии, член Немецкой ассоциации гипноза. 
                    Номер участника: DHV-01643
                  </p>
                  <p>
                    <strong>Дипл. Системный бизнес и менеджмент коуч (CAS/ECA)</strong> - получено в Швейцарии 
                    в Швейцарской академии коучинга -CAS
                  </p>
                  <p>
                    <strong>Дипл. Педагог дошкольного образования и психологии (A4+)</strong>
                  </p>
                  <p>
                    <strong>Воспитатель</strong> - получено в Казахстане в Университете Е.А. Букетова в Караганде(H+), 
                    признано как воспитатель в Германии Министерством науки, исследований и искусства Баден-Вюртемберга
                  </p>
                </div>
              </div>

              {/* Надзорный орган */}
              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">Надзорный орган</h2>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Вы можете в любое время обратиться с жалобой в компетентный надзорный орган. 
                  Ваш компетентный надзорный орган определяется федеральной землей вашего места жительства, 
                  работы или предполагаемого нарушения. Список надзорных органов (для непубличной сферы) 
                  с адресами можно найти по адресу:{' '}
                  <a 
                    href="https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html" 
                    className="text-rose-600 hover:text-rose-700 underline"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    www.bfdi.bund.de
                  </a>
                </p>
              </div>

              {/* Источники изображений */}
              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">
                  Источники используемых изображений и графики
                </h2>
                <div className="text-sm sm:text-base text-gray-700 space-y-3">
                  <p>
                    Некоторые изображения и/или фотографии на этой странице являются объектом авторского права 
                    123RF Limited и Freepik или авторизованных поставщиков, используемых в соответствии с 
                    лицензионными условиями. Эти изображения и/или фотографии не могут быть скопированы 
                    или загружены без разрешения 123RF Limited или Freepik.
                  </p>
                  <div className="space-y-2">
                    <p>
                      <a 
                        href="https://www.123rf.com" 
                        className="text-rose-600 hover:text-rose-700 underline"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Ссылка 123RF Stock Photos
                      </a>
                    </p>
                    <p>
                      <a 
                        href="https://www.freepik.com" 
                        className="text-rose-600 hover:text-rose-700 underline"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Ссылка Freepik
                      </a>
                    </p>
                  </div>
                  <p>
                    Мои фотографии от Тамары Бурк{' '}
                    <a 
                      href="https://www.tamabu.de" 
                      className="text-rose-600 hover:text-rose-700 underline"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      www.tamabu.de
                    </a>{' '}
                    и Меерим Кауфман{' '}
                    <a 
                      href="https://www.maphotos.de" 
                      className="text-rose-600 hover:text-rose-700 underline"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      www.maphotos.de
                    </a>{' '}
                    являются собственностью Alphavita.
                  </p>
                  <p className="text-xs sm:text-sm text-gray-500">
                    Источник: Создано с помощью генератора правовой информации канцелярии Зиберт
                  </p>
                </div>
              </div>

              {/* Ответственность за контент */}
              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">Ответственность за контент</h2>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Как поставщик услуг мы несем ответственность за собственный контент на этих страницах 
                  в соответствии с общими законами согласно § 7 Abs.1 DDG. Однако согласно §§ 8-10 DDG 
                  мы как поставщик услуг не обязаны контролировать переданную или сохраненную внешнюю информацию 
                  или исследовать обстоятельства, указывающие на незаконную деятельность.
                </p>
              </div>

              {/* Ответственность за ссылки */}
              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">Ответственность за ссылки</h2>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Наше предложение содержит ссылки на внешние веб-сайты третьих лиц, на контент которых 
                  мы не можем влиять. Поэтому мы не можем нести ответственность за этот внешний контент. 
                  За контент связанных страниц всегда отвечает соответствующий поставщик или оператор страниц.
                </p>
              </div>

              {/* Авторское право */}
              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">Авторское право</h2>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Контент и работы, созданные операторами страниц на этих страницах, подпадают под немецкое 
                  авторское право. Воспроизведение, обработка, распространение и любое использование за пределами 
                  авторского права требуют письменного согласия соответствующего автора или создателя. 
                  Загрузки и копии этой страницы разрешены только для частного, некоммерческого использования. 
                  Поскольку контент на этой странице не был создан оператором, соблюдаются авторские права третьих лиц. 
                  В частности, контент третьих лиц обозначен как таковой. Если вы все же заметите нарушение авторских прав, 
                  мы просим соответствующее уведомление. При обнаружении правовых нарушений мы немедленно удалим такой контент.
                </p>
              </div>

              {/* Предупреждение */}
              <div className="bg-white border border-gray-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">Предупреждение</h2>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  НЕТ ПРЕДУПРЕЖДЕНИЙ без предварительного письменного контакта. Если какой-либо контент или информация 
                  на этом веб-сайте или на частях этого веб-предложения нарушает права третьих лиц или вызывает 
                  проблемы с правом конкуренции в другой форме, мы просим в соответствии с §8 Abs. 4 UWG о быстром, 
                  соответствующем уведомлении без счета за расходы. Оспариваемая информация или контент будут затем 
                  удалены в разумные сроки или изменены в соответствии с правовыми требованиями без необходимости 
                  привлечения правового представителя. Привлечение правового представителя для платного предупреждения 
                  поставщика услуг не соответствует реальной или предполагаемой воле предупреждающего и, таким образом, 
                  является нарушением §13 Abs. 15 UWG из-за преследования посторонних целей как доминирующего мотива 
                  для инициации процедуры, особенно получения затрат как фактической причины. Это также соответствует 
                  нарушению действующей обязанности по снижению ущерба.
                </p>
              </div>

              {/* Файлы cookie */}
              <div className="bg-rose-50 border border-rose-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8">
                <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-dark-900">Файлы cookie</h2>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  Чтобы оптимально настроить наш веб-сайт для вас и постоянно улучшать его, мы используем файлы cookie. 
                  Продолжая использовать веб-сайт, вы соглашаетесь на использование файлов cookie. Дополнительную 
                  информацию о файлах cookie вы можете найти в нашей{' '}
                  <a 
                    href="/datenschutz" 
                    className="text-rose-600 hover:text-rose-700 underline font-medium"
                  >
                    Политике конфиденциальности
                  </a>.
                </p>
              </div>
            </motion.div>
          </div>
        </motion.section>
      </main>
      <Footer />
    </div>
  );
}
